import type { ReactNode } from 'react';
import { TickIcon } from '../icons';
import styles from './ui.module.css';

/**
 * Галочка-барьер перед необратимым действием.
 *
 * Своя, а не вкуишная, по той же причине, что `Toggle` и `Select`: платформа
 * рисует СПЛОШНОЙ малиновый квадрат с белой птичкой, а в макете это контур со
 * слабой заливкой и малиновой птичкой. Токенами это не выдавалось: цвет
 * заливки и цвет значка у VKUI один и тот же токен акцента, и развести их
 * было нечем.
 *
 * Внутри настоящий `<input type="checkbox">` — прозрачный и во всю коробку:
 * с ним работают клавиатура, фокус и скринридер, а подпись связана с полем
 * тем, что и он, и она лежат в одном `<label>`.
 *
 * Малиновая, а не бирюзовая: бирюзой в приложении отмечено ПРИНЯТОЕ, и той же
 * галочкой соглашаться на снос своих данных нельзя.
 */
export function ConfirmCheck({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}) {
  return (
    <label className={styles.confirmCheck}>
      <input
        type="checkbox"
        className={styles.confirmCheckInput}
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className={styles.confirmCheckBox}>
        {/* Цвет птичка берёт у коробки: та гасит его в прозрачный, пока не
            отмечено, и зажигает малиновым, когда отмечено. */}
        <TickIcon />
      </span>
      <span className={styles.confirmCheckText}>{children}</span>
    </label>
  );
}
